/* Keep */
import { SET_CURRENCY_CONVERSION } from '../constants';

export const currencyReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case SET_CURRENCY_CONVERSION:
            return {
                base: action.base,
                rates: action.rates,
            };

        default:
            return state;
    }
};

export default currencyReducer;
